import { useCallback, useMemo } from 'react';

import { useAppDispatch,useAppSelector } from 'app/hooks';
import type { RootState } from 'app/store';
import { DropDownInfo } from 'common/types/TypeDefs';

export function usePalmFilters(
    selectFilters: (state: RootState) => {
            keywords: string[];
        },
    addNewFilter: (payload: string) => {
            payload: string;
            type: string;
        },
    removeFilter: (payload: string) => {
            payload: string;
            type: string;
        },
    clearFilters: () => {
            payload: undefined;
            type: string;
        },
    dropdownProps?: DropDownInfo[]
) {

    const dispatch = useAppDispatch();
    const filters = useAppSelector(selectFilters);

    const addFilter = useCallback((filter: string) => {
        dispatch(addNewFilter(filter));
    }, [dispatch, addNewFilter]);

    const removeFilterHandler = useCallback((filter: string) => {
        dispatch(removeFilter(filter));
    }, [dispatch, removeFilter]);

    const clearFiltersHandler = useCallback(() => {
        dispatch(clearFilters());
    }, [dispatch, clearFilters]);

    const filterProp = useMemo(() => ({
        filters,
        addFilter,
        removeFilter: removeFilterHandler,
        clearFilters: clearFiltersHandler,
        dropdownProps
    }), [filters, addFilter, removeFilterHandler, clearFiltersHandler, dropdownProps]);

    return filterProp;

}
